import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import QuestionCircleIcon from 'adp-react-icons/lib/fa/question-circle';
import {
  Button,
  Textbox,
  Popover,
  PasswordStrengthIndicator,
  Alert,
  Tooltip,
  OverlayTrigger
} from 'adp-react-components';
import CheckCircleIcon from 'adp-react-icons/lib/fa/check-circle';
import TimesIcon from 'adp-react-icons/lib/fa/times-circle';
const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();

class AnswerYourQuestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstQuestion: '',
      secondQuestion: '',
      answer1: '',
      answer2: '',
      val: '',
      submit: 'SUBMIT',
      disabled: false
    };
  }

handleEnterKeyPress(e) {
  
    if (this.isAnswered() && e.charCode == 13) {
      
      e.preventDefault(); //preventing html5 default form submit
      this.onSubmit();
    }
  }


  onChangeAnswer2(value) {
      this.props.showErrorMessage('');
    this.setState({
      answer2: value
    });
  }
  onChangeAnswer1(value) {
      this.props.showErrorMessage('');
    this.setState({
      answer1: value
    });
  }
  componentDidMount() {
    fetch(context+'/enroll/adpPassword.faces?getQuestionsForm', {
      method: 'POST',
      //same-origin is needed to keep the cookies
      credentials: 'same-origin',

      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body:
        'getQuestionsForm=getQuestionsForm&getQuestionsForm:submitButton=&javax.faces.ViewState=' +
        Tier0.get('javax.faces.ViewState').value
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message);
          return;
        }
        if (data.success == 'true' || data.success == true) {
          this.setState({
            firstQuestion: data.fyp.qna.firstQuestion,
            secondQuestion: data.fyp.qna.secondQuestion,
            submit: 'SUBMIT',
            disabled: false
          });
        }
      });
  }

  onSubmit(event) {
    this.props.showErrorMessage('');
    fetch(context+'/enroll/adpPassword.faces?fypVerifyAnswersForm=', {
      method: 'POST',
      //same-origin is needed to keep the cookies
      credentials: 'same-origin',

      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
      },
      //need to get dynamic values from the text box.
      body:
        'fypVerifyAnswersForm=fypVerifyAnswersForm&fypVerifyAnswersForm:answer1=' +
        this.state.answer1 +
        '&fypVerifyAnswersForm:answer2=' +
        this.state.answer2 +
        '&fypVerifyAnswersForm:submitButton=&javax.faces.ViewState=' +
        Tier0.get('javax.faces.ViewState').value
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message);
          return;
        } else {
          fetch(context+'/enroll/adpPassword.faces?fypDeliveryForm', {
            method: 'POST',
            //same-origin is needed to keep the cookies
            credentials: 'same-origin',
            headers: {
              Accept:
                'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body:
              'fypDeliveryForm=fypDeliveryForm&otpType=' +
              this.props.selectedValue +
              '&fypDeliveryForm:submitButton=&javax.faces.ViewState=' +
              Tier0.get('javax.faces.ViewState').value
          })
            .then(response => {
              return response.json();
            })
            .then(data => {
              if (data.success == 'false' || data.success == false) {
                if (data.wizard.message == 'true') {
                  this.props.showSessionExpired();
                  return;
                }
                this.props.showErrorMessage(data.wizard.message);
                return;
              }

              this.props.showVerificationCode();
            });
        }
      });
  }
  isAnswered() {
    return this.state.answer1 != '' && this.state.answer2 != '';
  }
  render() {
    let isValid = this.isAnswered();
    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <form className="adp-form">
            <div className="form-group password">
              <div className="vdl-row">
                <div className="vdl-col-sm-14 vdl-col-xs-12">
                  <label htmlFor="fristQuestion">
                    {entities.decode(this.state.firstQuestion)}
                  </label>
                </div>
              </div>

              <div className="form-group password">
                <div className="input-group-full">
                  <Textbox
                    autoFocus
                    value={this.state.answer1}
                    type="password"
                    onChange={this.onChangeAnswer1.bind(this)}
                    onKeyPress={this.handleEnterKeyPress.bind(this)}
                  />
                </div>
              </div>
              {/* input-group-full */}
            </div>
            <div className="form-group password">
              <label htmlFor="confirmPassword">
                {entities.decode(this.state.secondQuestion)}
              </label>
              <div className="input-group-full">
                <Textbox                  
                  value={this.state.answer2}
                  type="password"
                  onChange={this.onChangeAnswer2.bind(this)}
                  onKeyPress={this.handleEnterKeyPress.bind(this)}
                />
              </div>
            </div>
            {/* form-group password */}
            <div className="form-group submit vdl-text-xs-center">
              <Button
                className="primary"
                onClick={this.onSubmit.bind(this)}
                disabled={!isValid}>
                {' '}
                {this.props.submit}
              </Button>
            </div>
            {/* form-group submit vdl-text-xs-center */}
          </form>
          {/* adp-form */}
        </div>
        {/* vdl-col-md-12 */}
      </div>
    );
  }
}

export default AnswerYourQuestion;



// WEBPACK FOOTER //
// ./src/scenes/admin-login/forgotflow/AnswerYourQuestion.js